import React from 'react';
export const Footer = () => {
  return <footer className="w-full bg-gray-800 py-8 px-4 text-center" data-id="element-49">
      <div className="max-w-4xl mx-auto" data-id="element-50">
        <p className="text-white text-sm" data-id="element-51">
          © {new Date().getFullYear()} Stressless Dogs. Alle rechten
          voorbehouden.
        </p>
      </div>
    </footer>;
};